import { isNetworkError } from '@/api/errors'

const sleep = (ms: number): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms))

export interface PollOptions<T> {
	delay: number
	shouldContinue: () => boolean
	isPending: (result: T) => boolean
	shouldRetry?: (error: unknown) => boolean
}

export async function pollUntil<T>(fetchStatus: () => Promise<T>, options: PollOptions<T>): Promise<T | null> {
	const { delay, shouldContinue, isPending, shouldRetry = isNetworkError } = options
	while (true) {
		if (!shouldContinue()) return null
		let result: T
		try {
			result = await fetchStatus()
		} catch (error) {
			if (shouldRetry(error) && shouldContinue()) {
				await sleep(delay)
				continue
			}
			throw error
		}
		if (!isPending(result)) return result
		await sleep(delay)
	}
}
